export const CARD_ALIGNMENT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
}
